<template>
  <div class="app flex-row backkk">
      <!-- <b-row> -->
          <b-col md="8" class="mobileviewloginbg" style="padding: unset;">
            <div>
              <img src="img/truck_logo_v1.png" alt="delivery-service"/>
            </div>
          </b-col>
          <b-col md="4" >
              <div class="logincard">
                  <b-card no-body style="padding: unset;">
                      <b-card-body style="padding: 25px 54px;">
                       <b-alert v-model="showAlert" variant="danger"  dismissible>
                        Login credential are incorrect!
                      </b-alert>
                       <b-form name="loginform" @submit.prevent="validateForm('loginform')" data-vv-scope="loginform">
                          <div class="loginimg">
                            <img src="img/rb_logo_v1.png" alt="ROCEKETBEE'S Logo" style="height: 80px;"/>
                          </div>
                          <!-- <h1>Login</h1> -->
                          <!-- <p class="text-muted">Sign In to your account</p> -->
                          <!-- Country DropDown -->
                          <!-- <b-input-group class="mb-4">
                            <b-input-group-prepend><b-input-group-text><i class="fa fa-globe"></i></b-input-group-text></b-input-group-prepend>
                           
                            <b-form-select v-model="country" name="country" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('loginform.country') }">
                                  <option value="">--Select Country--</option>
                                  <option value="ME">ME/UAE</option>
                                  <option value="KSA">KSA</option>
                                  
                                </b-form-select>
                          </b-input-group>
                          <b-input-group class="mb-3">
                              <span class="icon has-text-warning">
                               <i class="fa fa-warning" v-show="errors.has('country')" ></i>
                              </span>
                              <span v-show="errors.has('loginform.country')" id="passwmsgtxt" class="help text-danger">{{ errors.first('loginform.country') }}</span>
                          </b-input-group> -->
                          <!-- Country DropDown End -->
        
                          <b-input-group class="mb-3">
                            <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                            <b-form-input type="text" id="email" name="email" class="form-control" placeholder="Username" autocomplete="username email" v-model="email"   v-validate="'required|email|min:6'" :class="{'input': true, 'text-danger': errors.has('loginform.email') }"/>
                          </b-input-group>
                          <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('email')" ></i>
                          </span>
                          <span v-show="errors.has('loginform.email')" id="emailmsgtxt" class="help text-danger">{{ errors.first('loginform.email') }}
                          </span>
                       
                          </b-input-group>
                          <b-input-group class="mb-4">
                            <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                            <b-form-input type="password" id="password" name="password" class="form-control" v-model="password"  placeholder="Password" v-validate="'required|min:6'" :class="{'input': true, 'text-danger': errors.has('loginform.password') }"  autocomplete="current-password"/>
                          </b-input-group>
                          <b-input-group class="mb-3">
                              <span class="icon has-text-warning">
                               <i class="fa fa-warning" v-show="errors.has('password')" ></i>
                              </span>
                              <span v-show="errors.has('loginform.password')" id="passwmsgtxt" class="help text-danger">{{ errors.first('loginform.password') }}</span>
                          </b-input-group>
        <!-- class="icon-lock" -->
                          
                          <!-- captcha code
                           style="width:100%; height:50px" -->
                          <!-- <b-input-group class="mb-4"> -->
                              <b-input-group class="mb-4">
                                <b-input-group-prepend><b-input-group-text><i class="fa fa-shield" aria-hidden="true"></i></b-input-group-text></b-input-group-prepend>
                                <b-form-input  class="form-control"  type="text" name="text" id="text" placeholder="Captcha" v-model="text" style=" padding: 6px 12px;" 
                                v-validate="'required|min:4'" :class="{'input': true, 'text-danger': errors.has('loginform.text') }"   @change="checkcaptcha" autocomplete="off"/>
                                </b-input-group>
                                  <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i class="fa fa-warning" v-show="errors.has('text')" ></i>
                                      </span>
                                      <span v-show="errors.has('loginform.text')" id="text" class="help text-danger">{{ errors.first('loginform.text') }}
                                      </span>
                                   
                                  </b-input-group>
                                  <b-alert v-model="capAlert" variant="danger"  dismissible>
                                    Invalid Captcha!
                                  </b-alert>
                              
        
                               <!-- </b-input-group> -->
                               <b-input-group class="mb-4">
                                <captcha-code
                                  :captcha.sync="code"
                                  @on-change="handleChange"
                                  ref="captcha"
                                 style="width: 20px; height: 50px; display:none"
                              class="captcha-style"
                                 ></captcha-code>
                                  <div class="captcha-area">
                                     <span class="captcha">{{code}}</span>
                                  </div>
                                 <i class="fa fa-refresh" aria-hidden="true" @click="handleClick" style="font-size: 30px;
                                 margin-top: 10px;
                                        margin-left: 12px;
                                        color: #24a0ed;"></i>
                               <!--  <div>
                                   <input style="width:90%; height:30px;margin:5px 0" type="text" name="text" id="text" v-model="text" > &nbsp; 
                                </div> -->
                                <!-- <b-input-group class="mb-4">
                                <b-form-input  type="text" name="text" id="text" v-model="text" />
                              </b-input-group>
         -->                      <!-- <div>
                              <b-button :disabled="!isActive" @click="submitClick"  >submit</b-button>&nbsp;
                              &nbsp;
                              &nbsp;
                              <b-button @click="resetInput" >Reset</b-button>
                              </div> -->
                            </b-input-group>
                          <b-row>
                            <div id="overlay" style="display:none">
                             <div class="loader"></div>
                            </div>
                             <b-col cols="12" >
                              <b-button type="submit" variant="primary"  block>Login</b-button>
                            </b-col>
                            <b-col cols="6" class="text-right">
                            
                            </b-col>
                          </b-row>
                        </b-form>
                      </b-card-body>
                  </b-card>
              </div>
          </b-col>
      <!-- </b-row> -->
  </div>
</template>


<script>
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
import Vue from 'vue'
import CaptchaCode from "vue-captcha-code";
const axios = require('axios')
  //console.log('url:',CONSTANTS.API_URL);


export default {
name: 'login',
components: {
  CaptchaCode,
},
data () {
  return {
    password: '',
    country: '',
    email: '',
    json: null,
    flag: false,
    showAlert: false, 
    // captcha
    capAlert:false,
    code: "",
    text:'',
    isActive:true
  }
},
created () {
  var userInfo = localStorage.getItem('userData')
  if (userInfo) {
    this.flag = false
    if (auth.loggedIn()) {
      this.$router.push('/login').catch(()=>{});
    }else{
      this.$router.push('/dashboard_adv'+'/normal').catch(()=>{});
    }
  } else {
    this.$router.push('/login').catch(()=>{});
  }
},
    mounted: function() {

// alert("heelo");
// code for disble right click,ctrl+f12,ctrl+shift+i
var message=""; 
function clickIE() {if (document.all) {(message);return false;}} 
function clickNS(e) {if 
(document.layers||(document.getElementById&&!document.all)) { 
if (e.which==2||e.which==3) {(message);return false;}}} 
if (document.layers) 
{document.captureEvents(Event.MOUSEDOWN);document.onmousedown=clickNS;} 
else{document.onmouseup=clickNS;document.oncontextmenu=clickIE;} 



document.oncontextmenu=new Function("return false") ;
document.onkeydown = function(e) {
      if (e.ctrlKey && e.shiftKey && 
          ( 
           e.keyCode === 85 || 
           e.keyCode === 117 || e.keyCode=== 16 || e.keyCode=== 73 )) {
          return false;
      }else if(e.keyCode == 123){
          return false;
      } else {
          return true;
      }
}


},

methods: {
  // start
  // myListener: function() {
  //   alert("You pressed the control+shift+i key!");
  // },

  handleClick() {
    this.$refs.captcha.refreshCaptcha();
  },
  handleChange(code) {
    console.log("code:", code);
  },

  checkcaptcha(){
    if(this.text===this.code){
      this.capAlert=false;
    }
    else{
       this.capAlert=true;
    }
  },
  validateForm (scope) {
  
      this.$validator.validateAll(scope).then((result) => {
      if (result) {
        if(this.text!==''){
          if(this.text===this.code){
          document.getElementById("overlay").style.display = "block";  
        const loginObj = {
          // hub_id:`${userInfo.pickuplocationmasterid}`,
          sysemailid: this.email,
          syspassword: this.password,
          // syscountry: this.country
        }
        // Vue.http.headers.common['country'] =this.country; 
        //consol
        if (this.email !== '' && this.password !== '') {
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/validatesystemuserlogin`, loginObj)
            .then((result) => {
              document.getElementById("overlay").style.display = "none";
              // console.log('result',result);
              var userData = result.body.returnvalue[0]
              if (result.body.returnmsg.toLowerCase() === 'successful') {
                localStorage.setItem('userData', JSON.stringify(userData))
                if (result.body.returnvalue[0].approval_action && result.body.returnvalue[0].approval_action.length) {
                    var approval_action = result.body.returnvalue[0].approval_action;
                   localStorage.setItem('approval_action', JSON.stringify(approval_action))
                }
                else{
                  localStorage.setItem('approval_action', '')
                }
                localStorage.setItem('Coduser', "codvaliduser")
                var d1 = new Date()
                localStorage.setItem('activeTime', d1.getMinutes())
                Vue.http.headers.common['x-access-token']  = userData['token'];
                // Vue.http.headers.common['country'] =userData['country']
              //  console.log(this.$http.headers.common['x-access-token']);
                //console.log(this.$http);
                // alert(userData.defaultpage)
                if(userData.defaultpage)
                {
                  if(userData.defaultpage == "trip_history"){
                    this.$router.push(userData.defaultpage).catch(()=>{});
                  }
                  else {
                    // console.log("uuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuu",userData)
                  this.$router.push(userData.defaultpage+'/normal').catch(()=>{});
                  }
                  // this.$router.push('/dashboard_adv'+'/normal').catch(()=>{});
                }
                else if (userData.defaultpage == null )
                {
                  this.$fire({
                text: "Access rights not set.Please contact Admin.",
                type: "error",
                timer: 30000
              });
                   // alert("Access rights not set.Please contact admin.");
                }
                else
                {
                  this.$router.push('/dashboard_adv'+'/normal').catch(()=>{});
                }

                  
                 
                
              }//resultbody closing
              
              else {
                if (result.body.returnmsg === 'unsuccessful') {
              
                  this.showAlert=true
                  
                }
              }
            })//axios result closing
        }//email closing
          }//captcha check closing
          else {
                if (this.text !== this.code) {
              
                  this.capAlert=true
                  
                }
              }
        }//captcha Text closing
      }//result closing
    })//validation closing
    // }
    // else{
    //   alert('invalid captcha');
    // }
    // } 
  // else{
  //     alert('please enter the captcha')
  //   }
  },//validateForm function closing
 
  fetchCompanyInfo: function () {},
  toggleInfoModal: function () {
    this.toggleInfo = !this.toggleInfo
  }
}
};
</script>
<style>

.app.flex-row.backkk{
  min-height:100vh;
  display:flex;
}

.backkk {
  background-color: #ebb97f;
}
.logincard {
  margin: 50px 0px;
}
.loginimg {
  text-align: center;
  margin-bottom: 20px;
}
.captcha-area .captcha{
  font-size: 28px;
  letter-spacing: 20px;
  margin-left: 70px;
}

.captcha-area{
  width: 225px;
   margin-left: 1px; 
} 
.captcha {
    user-select: none;  /* Prevents text selection */
    pointer-events: none; /* Disables any mouse interactions */
}

.captcha-area {

    -webkit-user-drag: none; /* Prevents drag and drop in WebKit browsers */
    user-select: none;
}

@media(max-width: 767px){

.logincard {
    margin: 0px 0px;
    position: relative;
}
.mobileviewloginbg{
   display: none;
}
.logincard .card-body{
  padding: 25px 32px!important;
}
.logincard .card{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 50%);
    width: 90%;
}

}
.captcha-style {
  user-select: none;  /* Prevent text selection */
  pointer-events: none; /* Disable interactions */
}

</style> 
